/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Carousel } from '@msdyn365-commerce/components';
import { IModuleProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import { Module } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICarouselState } from '@msdyn365-commerce-modules/carousel';

import { ICarouselProps } from '../definition-extensions/carousel.ext.props.autogenerated';

export interface ICarouselViewPropsExtension extends ICarouselProps<{}>, ICarouselState {
    closeAnimation: string;
    carouselContainer: IModuleProps;
    telemetryContent: ITelemetryContent;
    next(): void;
    previous(): void;
    onIndicatorsClickHandler(): void;
    handleDismissCarousel(): void;
    handleOnExited(): void;
    handleOnExiting(): void;
}

/**
 * Returns item slots.
 * @returns Array of item slots.
 * @param props -Props.
 */
const retrieveItems = (props: ICarouselViewPropsExtension): React.ReactNode[] => {
    if (props.activeIndex === undefined) {
        props.next();
    } else if (props.activeIndex >= props.slots.promoContentItem.length) {
        props.onIndicatorsClickHandler();
    }
    let items = [];
    items = props.slots && props.slots.promoContentItem && props.slots.promoContentItem.length > 0 ? props.slots.promoContentItem : [];
    return items;
};
const CarouselView: React.FC<ICarouselViewPropsExtension> = props => (
    <Module {...props.carouselContainer} {...props.renderModuleAttributes(props)}>
        <Carousel
            className={classnames(props.closeAnimation, props.slots.promoContentItem.length > 0 && 'msc-carousel-promo')}
            activeIndex={props.activeIndex}
            next={props.next}
            previous={props.previous}
            pause={props.config.pauseOnHover ? 'hover' : false}
            ride={props.config.autoplay ? 'carousel' : undefined}
            autoplay={props.config.autoplay}
            interval={props.config.interval}
            transitionType={props.config.transitionType ? props.config.transitionType : undefined}
            items={retrieveItems(props)}
            hideFlipper={props.config.hideFlipper}
            dismissEnabled={props.config.dismissEnabled}
            onIndicatorsClickHandler={props.onIndicatorsClickHandler}
            handleDismissCarousel={props.handleDismissCarousel}
            dismissCarouselAriaText={props.resources && props.resources.ariaLabelForDismissButton}
            indicatorAriaText={props.resources && props.resources.ariaLabelForSlide}
            directionTextPrev={props.resources && props.resources.flipperPrevious}
            directionTextNext={props.resources && props.resources.flipperNext}
            handleOnExited={props.handleOnExited}
            handleOnExiting={props.handleOnExiting}
            telemetryContent={props.telemetryContent}
            keyboard={props.config.keyboard}
            hideIndicator={props.config.hideIndicator}
        />
    </Module>
);

export default CarouselView;
